module.exports = __webpack_public_path__ + "img/kalender-active.d8890f6.png";